import { render } from "./incredi-transition.vue?vue&type=template&id=552fb642"
import script from "./incredi-transition.vue?vue&type=script&lang=js"
export * from "./incredi-transition.vue?vue&type=script&lang=js"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__